import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { isDevMode, LOCALE_ID, NgModule, provideZoneChangeDetection } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { provideTransloco, TranslocoService } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './core/transloco/transloco.http-loader';
import { DialogsModule } from './dialogs/dialogs.module';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';
import { FuseModule } from '../@fuse';
import { FuseConfigModule } from '../@fuse/services/config/config.module';
import { appConfig, CustomDateAdapter } from './core/config/app.config';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from './core/paginator/custom-pagination-intl.service';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

registerLocaleData(localeEs, 'es-ES');

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        DialogsModule,
    ],
    providers: [
        provideTransloco({
            config: {
                availableLangs: ['es-ES', 'en-GB', 'pt-PT'],
                defaultLang: 'es-ES',
                fallbackLang: 'es-ES',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader
        }),
        provideZoneChangeDetection(),
        {
            provide: LOCALE_ID,
            deps: [TranslocoService],
            useFactory: (translocoService: TranslocoService) => translocoService.getActiveLang()
        },
        { provide: MAT_DATE_LOCALE, useValue: LOCALE_ID },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntl
        },
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
